import { useLang } from "@/context/LangContext";
import { COPY } from "./landingCopy";
import { Header } from "./landingPrimitives";
import { HeroSection } from "./HeroSection";
import { UnderstandSection } from "./UnderstandSection";
import { WinSection } from "./WinSection";
import { KeepSection } from "./KeepSection";
import { HandleSection } from "./HandleSection";
import { TalkVisionSection } from "./TalkVisionSection";

// Production V2 Landing composer.
//
// Renders the same approved six-section Features composition that
// /design-proof/features renders — by sharing the exact same section
// components, so both routes are pixel-identical by construction.
//
// Gated by LEVI_LANDING_V2_ENABLED (default OFF). See Landing.jsx +
// leviLandingV2Flag.js for the flag-reading and route composition.
//
// The design-proof route remains the authoritative frozen visual
// reference. This composer intentionally mirrors its structure
// exactly, minus the "DESIGN PROOF · not a production route" stamp
// which has no place in production.
export default function LandingV2() {
  const { lang, setLang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <div className="min-h-screen bg-white" data-testid="landing-v2-root">
      <Header c={c} lang={lang} setLang={setLang} />
      <HeroSection c={c} />
      <UnderstandSection c={c} />
      <WinSection c={c} />
      <KeepSection c={c} />
      <HandleSection c={c} />
      <TalkVisionSection c={c} />
    </div>
  );
}
